export const HEADER_CATEGORIES_EXTEND_ITEMS = 7;

export const HEADER_CATEGORIES_SHOW_PARAM = "hCat";
